import type { AppAnalyticsUserProperties } from './appAnalyticsTypes';

type EmployeeLike = {
  _id?: string;
  bp_owner_id?: string;
  bp_employee_name?: string;
  bp_employee_phone_number?: string;
  bp_owner_phone_number?: string;
  bp_employee_email_address?: string;
  bp_employee_role?: string;
};

type LocationLike = {
  _id?: string;
  bp_location_name?: string;
  bp_location_type?: string;
};

type BusinessLike = {
  name?: string;
};

/**
 * Build identify payload from in-app auth/location slices.
 * Call only when employee `_id` is known.
 */
export function buildAppAnalyticsIdentify(input: {
  employee?: EmployeeLike | null;
  location?: LocationLike | null;
  business?: BusinessLike | null;
}): AppAnalyticsUserProperties | null {
  const userId = String(input.employee?._id || '');
  if (!userId) return null;

  const locationTypeRaw = String(
    input.location?.bp_location_type || '',
  ).toLowerCase();
  const location_type =
    locationTypeRaw === 'test' || locationTypeRaw === 'real'
      ? (locationTypeRaw as 'real' | 'test')
      : undefined;

  return {
    user_id: userId,
    owner_id: input.employee?.bp_owner_id
      ? String(input.employee.bp_owner_id)
      : undefined,
    name: input.employee?.bp_employee_name || undefined,
    phone_number:
      input.employee?.bp_employee_phone_number ||
      input.employee?.bp_owner_phone_number ||
      undefined,
    email: input.employee?.bp_employee_email_address || undefined,
    role: input.employee?.bp_employee_role || undefined,
    location_id: input.location?._id
      ? String(input.location._id)
      : undefined,
    location_name: input.location?.bp_location_name || undefined,
    location_type,
    business_name: input.business?.name || undefined,
  };
}
